// extracted by mini-css-extract-plugin
export default {"checkBox":"CheckBoxPrimary_checkBox__U99t0"};